<template>
  <!-- D: 선택옵션 결과: PC -->
  <div class="c-option-choice">
    <div class="labels">
      <strong class="label">선택 옵션 초기화</strong>
      <button
        type="button"
        class="c-btn-refresh"
        @click="() => emits('unsetAll')"
      >
        <i class="c-icon icon-refresh"></i>
      </button>
    </div>
    <div :class="{ 'choice-area': props.selectedCategories.length > 0 }">
      <div
        v-for="item in props.selectedCategories"
        :key="item.clsfCd"
        class="c-option-item"
      >
        <span class="text">
          {{ item.clsfNm }}(<span class="system">{{ item.productCount }}</span
          >)
        </span>
        <button typee="button" class="btn-delete" @click="removeSelect(item)">
          <i class="c-icon icon-medium-x size-xxsmall"></i>
          <span class="sr-only">삭제</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, defineProps, defineEmits } from "vue";

const emits = defineEmits(["unsetAll", "selectChanged"]);

const props = defineProps({
  selectedCategories: {
    type: Array,
    required: true,
  },
});

onMounted(() => {});

const removeSelect = (item) => {
  item.selected = false;
  emits("selectChanged");
};
</script>
